
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/web-cams",
      function () {
        return require("private-next-pages/web-cams.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/web-cams"])
      });
    }
  